import React, {ReactElement, useEffect} from "react"
import {init as initSentry} from '@sentry/react';
import Map from "@ui/components/map"
import {useStore} from "@ui/stores"
import Services from "@ui/components/services"
import Data from "@ui/components/map/Data"
import Buttons from "@ui/components/map/Buttons";
import NoSleep from 'nosleep.js';

const noSleep = new NoSleep();

const App = (): ReactElement => {
	const {movement, dictionary, profile, layer} = useStore()

  useEffect(() => {
    initSentry({
      dsn: process.env.SENTRY_DSN,
      sendDefaultPii: true
    })

		movement.init()
	  dictionary.init()
    profile.init()
    layer.init()

    document.addEventListener("click", function enableNoSleep() {
      document.removeEventListener("click", enableNoSleep, false)
      noSleep.enable()
    }, false)
  }, [])

	return (
		<div className="app">
			<Map />
			<Services />
			<Data />
			<Buttons />
		</div>
	)
}

export default App
